import { LVStrings } from "@my-dld/assets/strings";

export enum Mode {
	VIEW = "view",
	EDIT = "edit",
	CREATE = "create",
}

export enum OwnerType {
	INDIVIDUAL = 1,
	COMPANY = 2,
}

export interface ENocMLookupData {
	identity?: number;
	nameEn?: string;
	nameAr?: string;
	parentId?: any;
}

export enum ENocMLookUp {
	NOC_REQUESTER_TYPE = "NOC_REQUESTER_TYPE",
	LICENSE_ISSUE_AUTHORITY = "LICENSE_ISSUE_AUTHORITY",
	COUNTRIES = "COUNTRIES",
	OWNERSHIP_TYPE = "OWNERSHIP_TYPE",
	COMPANY_DOCUMENTS = "COMPANYBUYER",
	EXPAT_DOCUMENTS = "EXPAT",
	NOC_ELIGIBILITY_STATUS = "NOCELIGIBILITYSTATUS",
	ENOCSTATUS = "ENOCSTATUS",
	GENDER = "GENDER",
}

export const ENocLookUpKeys = {
	[ ENocMLookUp.COUNTRIES ]: "Countries",
	[ ENocMLookUp.OWNERSHIP_TYPE ]: "OwnershipTypes",
	[ ENocMLookUp.NOC_REQUESTER_TYPE ]: "NOCRequestTypes",
	[ ENocMLookUp.LICENSE_ISSUE_AUTHORITY ]: "LicenseIssueAuthorities",
	[ ENocMLookUp.COMPANY_DOCUMENTS ]: "CompanyDocuments",
	[ ENocMLookUp.EXPAT_DOCUMENTS ]: "IndividualDocuments",
	[ ENocMLookUp.NOC_ELIGIBILITY_STATUS ]: "NocEligibilityStatus",
	[ ENocMLookUp.ENOCSTATUS ]: "ENOCStatus",
	[ ENocMLookUp.GENDER ]: "Genders",
};

export const LookUpKeys = [ ENocMLookUp.NOC_REQUESTER_TYPE, ENocMLookUp.LICENSE_ISSUE_AUTHORITY, ENocMLookUp.COUNTRIES, ENocMLookUp.OWNERSHIP_TYPE,
	ENocMLookUp.COMPANY_DOCUMENTS, ENocMLookUp.EXPAT_DOCUMENTS, ENocMLookUp.NOC_ELIGIBILITY_STATUS, ENocMLookUp.ENOCSTATUS ];

export const RemarkAction = {
	actionId: "ViewRemark",
	color: "blue",
	englishName: LVStrings.view_remarks.en,
	arabicName: LVStrings.view_remarks.ar,
};

const CancelAction = {
	actionId: "CanCancelled",
	color: "red",
	englishName: LVStrings.cancel.en,
	arabicName: LVStrings.cancel.ar,
};
const ReSubmitAction = {
	actionId: "CanReSubmit",
	color: "green",
	englishName: LVStrings.re_submit.en,
	arabicName: LVStrings.re_submit.ar,
};

export const ViewAction = {
	actionId: "CanView",
	color: "green",
	englishName: LVStrings.view_details.en,
	arabicName: LVStrings.view_details.ar,
};

export const ACTIONS = [ RemarkAction, CancelAction, ReSubmitAction ];

export interface ENocMApplication {
	id?: number;
	requestNumber?: string;
	submitDate: string;
	status?: ENocMLookupData;
	propertyNumber?: string;
	propertyInfo?: NameValue;
	ownerAssociation?: ENocMLookupData;
	eligibility?: ENocMLookupData;
	ownerNumber?: string;
	remarks?: string;
	total_Obligations?: string;
	ownerName?: NameValue;
	actions?: ENocMAction[];
	documents?: EnocMollakDocuments[];
}

export interface ENocMAction {
	actionId: string;
	color?: string;
	englishName?: string;
	arabicName?: string;
}

export interface ENocMollakData {
	id?: number;
	mollakPropertyId?: number;
	requestInfo?: RequestInfo;
	buyerInfo?: BuyerInfo[];
	workflowComment?: string;
	recordSourceId?: number;
	property?: PropertyData;
	owners?: any[];
	nocReferenceNo?: string;
	remarks?: string;
	documents?: EnocMollakDocuments[];
	mode?: Mode;
	totalArea?: number;
}

export interface PropertyData {
	propertyNumber?: string;
	landNumber?: string;
	dewa?: string;
	mollakPropertyId?: number;
	tabuPropertyId?: number;
	lat?: number;
	lon?: number;
	areaId?: number;
	propertyGroup?: ENocMLookupData;
	propertyType?: ENocMLookupData;
	propertySubType?: ENocMLookupData;
	usage?: ENocMLookupData;
	buildingName?: NameValue;
	applicableArea?: number;
}

export interface RequestInfo {
	requestType?: ENocMLookupData;
	owner?: ENocMLookupData;
	name?: NameValue;
	contact?: Contact;
	documents?: EnocMollakDocuments[];
}

interface NameValue {
	englishName?: string;
	arabicName?: string;
}

interface Contact {
	email?: string;
	mobile?: string;
}

// export interface EnocMDocLookup {
//     englishName: string;
//     arabicName: string;
//     EntityDocumentId?: number;
//     Path?: string;
//
//     doc?: EnocMollakDocuments;
// }

export interface eNocUploadDoc {
	identity: any;
	fileName?: string;
	fileSize?: number;
	localData?: string;
	localFile?: File;
	type?: string;
	fileUrl?: string;
}

export interface EnocMollakDocuments {
	docs?: eNocUploadDoc;
	id?: string;
	identity?: any;
	serverId?: string;
	url?: string;
	documentType?: string;
	documentTypeId?: number;
	IsRequired?: boolean;
	name?: ENocMLookupData;
	Path?: string;
	nameEn?: string;
	nameAr?: string;
	documentCategory?: ENocMLookupData;
}

interface DateValidity {
	startDate?: string;
	endDate?: string;
}

interface AdditionalProps {
	CompanyNameEn?: string;
	CompanyNameAr?: string;
	ManagerNameEn?: string;
	ManagerNameAr?: string;
	PersonNameEn?: string;
	PersonNameAr?: string;
	email?: string;
	mobile?: string;
	startDate?: string;
	endDate?: string;
	genderId?: number;
	isCompany?: boolean;
}

export interface BuyerInfo extends AdditionalProps {
	index?: number;
	participantId?: number;
	isUAEResident?: boolean;
	ownershipType?: ENocMLookupData;
	emiratesID?: string;
	companyName?: NameValue;
	tradeLicenseNumber?: string;
	licenseAuthority?: ENocMLookupData;
	passportNumber?: string;
	passportValidity?: DateValidity;
	nationality?: ENocMLookupData;
	contact?: Contact;
	managerName?: NameValue;
	documents?: EnocMollakDocuments[];
	mode?: Mode;
	gender?: ENocMLookupData;
	birthDate?: string;
	birthPlace?: string;
	emiratesIdExpiry?: string;
	passportIssuedBy?: string; // passportIssuePlace
	propertyShareValue?: number;
	nocLetterBuyerID?: number;
}

export interface TabuPerson {
	ParticipantId: number;
	PersonNameAr: string;
	PersonNameEn: string;
	Email: string;
	Mobile: string;
	BirthDate: string;
	BirthPlaceEn: string;
	BirthPlaceAr: string;
	EIDExpiryDate: string;
	GenderId: number; // 0- male, 1- female
	CountryId: number;
	CountryEnglishName: string;
	CountryArabicName: string;
	PassportNumber: string;
	PassportIssuePlaceArabic: string;
	PassportIssuePlaceEnglish: string;
	PassportIssueDate: string;
	PassportExpiryDate: string;
}

export interface EIdaPerson {
	nameEn: string;
	nameAr: string;
	genderId: number;  // 1- male, 2- female
	passport: string;
	emiratesId: string;
	nationalityEntity: ENocMLookupData;
	mobile: string;
	email: string;
	birthDate: string;
	passportExpiryDate: string;
	passportIssueDate: string;
	emiratesIdExpiryDate: string;
	passportIssuePlace: string;
	placeOfBirth: string;
}
